<template>
  <div class="flex h100">
    <div class="w90 bg_f0 h100 over-auto text-center">
      <ul>
        <li class="l-h-60 fz-13 fw-500 c1 pr bg_f0  " v-for="(item, index) in navList" :key="index"
            @click="getNav(index)" :class="{ active: activeIndex == index }">
          <div class="w80 text-hide m0-auto">{{ item.name }}</div>
          <div class="active_line" v-if="activeIndex == index"></div>
        </li>
      </ul>
    </div>
    <div class="flex1 h100 over-auto ptrl-20-12-25 box-s" v-if="!threeShow">
      <ul>
        <li class="fw-500 c1 mb-15 every_all" v-for="(item, index) in list" :key="index">
          <div class="  fz-17 l-h-24 mb-15">{{ item.name }}</div>
          <ul class="flex-wrap">
            <li class="every_class"
                :class="{ 'every_active_green': tag == 0 && aindex === index && aInnerIndex === innerIndex && index != 0 && (index % 7 == 0 || index == 3 ),'every_active_skyblue': tag == 0 && aindex === index && aInnerIndex === innerIndex && index != 0 && (index % 6 == 0 || index == 2),'every_active': tag == 0 && aindex === index && aInnerIndex === innerIndex && index != 0 && (index % 5 == 0 || index == 1),'every_active_orange': tag == 0 && aindex === index && aInnerIndex === innerIndex && index % 4 == 0,  'bluebg': index != 0 && (index % 5 == 0 || index == 1), 'skyblue': index != 0 && (index % 6 == 0 || index == 2), 'green': index != 0 && (index % 7 == 0 || index == 3 ), 'orange': index % 4 == 0}"
                v-for="(innerItem, innerIndex) in item.child" :key="innerIndex"
                @click="chooseItem(0, innerItem,index, innerIndex)">{{ innerItem.name }}
            </li>
          </ul>
        </li>
      </ul>
      <ul class="flex-wrap fw-500">
        <li class="every_class bluebg" :class="{ 'every_active':tag == 1 && nindex === index }"
            v-for="(item, index) in noList" :key="index" @click="chooseItem(1, item, index)">{{ item.name }}
        </li>
      </ul>
    </div>
    <div class="flex1 h100 over-auto ptrl-20-12-25 box-s" v-if="threeShow">
      <span class="back_menlei" @click="backMenlei">点击返回</span>
      <!-- <ul v-if="threeList.length > 0"> -->
      <ul>
        <li class="fw-500 c1 mb-15 every_all" style="margin-top: 30px;">
          <ul class="flex-wrap">
            <li class="every_class orange" v-for="(innerItem, innerIndex) in threeList" :key="innerIndex"
                @click="chooseItem(0, innerItem,index, innerIndex)">{{ innerItem.name }}
            </li>
          </ul>
        </li>
      </ul>
      <span class="no_data" v-if="threeList.length == 0">暂无数据</span>
    </div>
    <loading :loadFlag="loadFlag"></loading>
    <!-- 年份遮罩层 -->
    <van-overlay :show="showService" v-if="showService" :custom-style="{background:'rgba(0,0,0,0.8)'}">
      <div class=" w315 ps-45 b-radius-6 ptb-20 box-s bg_f text-center" @click.stop style="z-index:999999999;">
        <div class="fz-15 fw-500 c1">请先选择入学年份</div>
        <div class="writeInfo">
          <div class="phone-ipt" @click="sheetClick('级')">
            {{ join_year }}
            <!-- <input type="text" placeholder="点击选择" v-model="join_year" @click="sheetClick('级')"/> -->
          </div>
        </div>
        <div class="wh_240_40 b-radius-6 c7 bg_49 fz-13 fw-500 m0-auto" @click="yearOk">确定</div>
        <!-- <div class="iconfont icon-chahao icon" @click="showService = false"></div> -->
      </div>
    </van-overlay>
    <!-- 年份  -->
    <van-popup v-model="showYear" round position="bottom">
      <van-picker
          show-toolbar
          value-key="yearVal"
          :columns="yearData"
          @cancel="showYear = false"
          @confirm="yearConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import {MajorList, userMajor} from '@/api/api.js'
import loading from "@/components/loading"

export default {
  components: {
    loading
  },
  data() {
    return {
      threeShow: false,//门类下专业是否显示（点击门类后显示的）
      threeList: [
        // {id:1,name:'计算机'},
        // {id:2,name:'建筑'},
      ],//门类下的专业数据

      showService: true,//是否年份遮罩层
      yearData: [],
      unitType: '',
      showYear: false,
      join_year: '点击选择',
      join_year_num: '',//选定的年份数字

      activeIndex: 0, //导航选中index
      tag: 0, //标记点中的是有标签还是无标签的
      aindex: '',//有标签外部index
      aInnerIndex: '',//有标签内部index
      nindex: '',//无标签选中index
      navList: [],
      list: [],
      noList: [],
      loadFlag: false,
      membership: '6'
    };
  },
  watch: {
    activeIndex: {
      handler(newName, oldName) {
        console.log('点击了啥', newName, typeof newName)
        switch (newName) {
          case '0':
            this.membership = '6'
            break;
          case '1':
            this.membership = '3'
            break;
          default:
            this.membership = undefined
            break
        }
        if (newName == 0) {
          this.list = this.navList[newName].label ? this.navList[newName].label : []
          this.noList = this.navList[newName].child ? this.navList[newName].child : []
        } else {
          this.list = []
          this.noList = this.navList[newName].label ? this.navList[newName].label : []
        }

        this.tag = this.list.length == 0 ? 1 : 0
        this.aindex = ''
        this.aInnerIndex = ''
        this.nindex = ''
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    //返回门类选择
    backMenlei() {
      this.threeShow = false;
    },
    /** 选择级 年 */
    sheetClick(val) {
      this.showYear = true
      this.yearDataFun(val)
      this.unitType = val
    },
    /** 时间 */
    yearDataFun(unit) {
      let now = new Date();
      let year = now.getFullYear();
      let beforeYear = year, afterYear = year
      console.log('当前年', year)
      this.yearData = []
      for (let i = 0; i < 5; i++) {
        this.yearData.unshift({
          yearVal: (--beforeYear) + unit
        })
      }
      for (let i = 0; i < 6; i++) {
        this.yearData.push({
          yearVal: (afterYear++) + unit
        })
      }
    },
    async yearOk() {
      if (!this.join_year) {
        return this.$toast("请选择入学年份");
      }
      this.join_year_num = parseFloat(this.join_year.substr(0, this.join_year.length - 1));
      console.log('选择确定', this.join_year_num)
      let form = {}
      if (this.join_year_num >= 2023) {
        //2023级
        form = {join_year: this.join_year_num}
      }
      this.loadFlag = true
      const res = await MajorList(form)
      this.loadFlag = false
      this.navList = res.data
      this.list = this.navList[0].label ? this.navList[0].label : []
      this.noList = this.navList[0].child ? this.navList[0].child : [],
          console.log('nolist啊', this.noList)
      this.tag = this.list.length == 0 ? 1 : 0
      this.showService = false
    },
    // 年份选择后
    yearConfirm(value) {
      this.showYear = false;
      if (this.unitType === '级') {
        this.join_year = value.yearVal
        console.log('选择入学年份切变化', this.join_year)
      }
    },
    async initData() {
      this.loadFlag = true
      const res = await MajorList()
      this.loadFlag = false
      this.navList = res.data
      this.list = this.navList[0].label ? this.navList[0].label : []
      this.noList = this.navList[0].child ? this.navList[0].child : []
      this.tag = this.list.length == 0 ? 1 : 0
    },
    // 切换导航
    getNav(index) {
      this.activeIndex = index
    },
    async chooseItem(tag, item, index, innerIndex) {
      if (this.join_year_num >= 2023 && !this.threeShow && this.activeIndex == 0) {
        //获取门类下专业
        this.loadFlag = true
        let form = {type: 'menlei', menlei_id: item.id}
        const res = await MajorList(form)
        this.loadFlag = false
        this.threeList = res.data
        this.threeShow = true;
        return;
      } else {
        //直接获取专业
        this.$dialog.confirm({
          title: '提示',
          message: '专业只能选择一次，确定选择吗？',
        })
            .then(() => {
              this.chooseConfirm(tag, item, index, innerIndex)
            })
            .catch(() => {
            });
      }

    },
    async chooseConfirm(tag, item, index, innerIndex) {
      //start
      if (!tag) {
        this.tag = 0
        this.aindex = index
        this.aInnerIndex = innerIndex
        this.nindex = ''
      } else {
        this.tag = 1
        this.nindex = index
        this.aindex = ''
        this.aInnerIndex = ''
      }
      const params = {professional_classification_id: item.id}
      if (this.membership) params.membership = this.membership
      const res = await userMajor(params)
      if (res.code == 1000) {
        this.$store.commit('setClass', 1)
        this.$toast.success('提交成功')
        this.$store.commit('setClassName', item.name)
        localStorage.setItem('merFlag', 1)
        setTimeout(() => {
          this.$router.replace('/index')
        }, 600)
      } else {
        this.$toast(res.msg)
      }
      //end
    }
  }
};
</script>
<style lang="less" scoped>
.active {
  background: #FFFFFF;
}

.active_line {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 15px;
  width: 26px;
  height: 2px;
  background: #497CFF;
  border-radius: 1px;
}

.every_class {
  width: 104px;
  padding: 9px 9px;
  box-sizing: border-box;
  line-height: 20px;
  text-align: center;
  border-radius: 6px;
  font-size: 14px;
  margin: 0 20px 15px 0;
  box-sizing: border-box;
}

.every_class_border {
  border: 1px solid #E0E0E0;
}

.every_active {
  background: #497CFF;
  border: 1px solid #497CFF;
  color: #FFFFFF;
}

.every_active_orange {
  border: 1px solid #FF7D1B;
}

.every_active_skyblue {
  border: 1px solid #0CA4FF;
}

.every_active_green {
  border: 1px solid #24B349;
}

.orange {
  background: #fdf0e2;
  color: #FF7D1B;
}

.bluebg {
  background: #e2edfc;
  color: #497CFF;
}

.skyblue {
  background: #e3f6ff;
  color: #0CA4FF;
}

.green {
  background: #e2f8e5;
  color: #24B349;
}

.writeInfo {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .phone-ipt {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-weight: bold;
    font-size: 14px;
    outline: none;
    padding: 10px 15px;
    width: 70%;

    .year {
      text-align: center;
      cursor: pointer;
      outline: none; /* 移除焦点轮廓 */
      cursor: default; /* 设置鼠标光标样式 */
    }

  }
}

.back_menlei {
  position: absolute;
  left: 120px;
  color: #497CFF;
  font-size: 12px;
}

.no_data {
  margin-top: 120px;
  font-size: 12px;
  position: absolute;
  left: 210px;
  top: 100px;
}
</style>
